<div class="column serving">
    <div class="cell" [class.possession-icon]="isPossessionIconEnabled">
        @if (score?.currentlyServing === 1) {
            <span class="{{ icon }}"></span>
        }
    </div>
    <div class="cell" [class.possession-icon]="isPossessionIconEnabled">
        @if (score?.currentlyServing === 2) {
            <span class="{{ icon }}"></span>
        }
    </div>
</div>

<ng-container *ngIf="!hasExtended; else extendedScoreboard">
    @if (points) {
        <div class="column points">
            <div class="cell">
                <div [msValueSlider]="points.participant1.toString()"></div>
            </div>
            <div class="cell">
                <div [msValueSlider]="points.participant2.toString()"></div>
            </div>
            <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ sitecore.eventGrid.Scoreboard_P }}</div>
        </div>
    }
    @if (games) {
        <div class="column games divider">
            <div class="cell">
                <div [msValueSlider]="games.participant1.toString()"></div>
            </div>
            <div class="cell">
                <div [msValueSlider]="games.participant2.toString()"></div>
            </div>
            <div class="cell" *ngIf="points && !hideScoreBoardColumnFooter">{{ sitecore.eventGrid.Scoreboard_G }}</div>
        </div>
    }
    @if (sets) {
        <div class="column sets">
            <div class="cell">
                <div [msValueSlider]="sets.participant1.toString()"></div>
            </div>
            <div class="cell">
                <div [msValueSlider]="sets.participant2.toString()"></div>
            </div>
            <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ sitecore.eventGrid.ScoreboardSets }}</div>
        </div>
    }
</ng-container>

<ng-template #extendedScoreboard>
    <div class="column" *ngFor="let set of score.participant1.sets; index as i" [class.current-set]="score.participant1.sets[i].current">
        <div class="cell" [ngClass]="getHighlightedSetClass(score.participant1.sets[i])">{{ score.participant1.sets[i].points }}</div>
        <div class="cell" [ngClass]="getHighlightedSetClass(score.participant2.sets[i])">{{ score.participant2.sets[i].points }}</div>
    </div>
</ng-template>
